/**
 * PDP gallery — phone swipe (≤767px), carousel tablet (768–991px), tiles (≥992px) or slick carousel.
 */
(function () {
  'use strict';

  var PHONE_MAX = 767;
  var TILES_MIN = 992;
  var CAROUSEL_LEFT_THUMBS_MIN = 992;
  var MOBILE_MAX = PHONE_MAX;
  var prefetched = Object.create(null);
  var currentMode = null;
  var currentCarouselThumbLayout = null;
  var mobileIO = null;
  var tilesIO = null;
  var tilesLayoutTimer = null;

  function pdpSlideSel(notHidden) {
    var extra = notHidden ? ':not([hidden])' : '';
    return '.tcn-pdp-slide' + extra + ', .tcn-product-slide' + extra;
  }
  var TILES_SPAN_FULL = 6;
  var TILES_SPAN_HALF = 3;
  var TILES_SPAN_THIRD = 2;
  /* Half-row (3 cols) at 2:3 — wider images need full row to stay visible */
  var TILES_WIDE_ASPECT = 1.22;
  var TILES_TALL_ASPECT = 0.82;

  function isMobileGallery() {
    return window.innerWidth <= PHONE_MAX;
  }

  function isTilesViewport() {
    return window.innerWidth >= TILES_MIN;
  }

  function getDesktopLayout() {
    if (window.TCN_PDP_GALLERY_LAYOUT === 'tiles') return 'tiles';

    var control = document.querySelector('.gallery-control[data-pdp-desktop-layout]');
    if (control && control.getAttribute('data-pdp-desktop-layout') === 'tiles') return 'tiles';

    if (isTilesViewport() && document.querySelector('.tcn-pdp-tiles-grid.tcn-pdp-gallery-desktop-only')) {
      return 'tiles';
    }

    return 'carousel';
  }

  function getGallerySlider() {
    if (isMobileGallery() || (window.innerWidth < TILES_MIN && document.querySelector('.gallery-control--tiles'))) {
      var $carousel = jQuery('.gallery-control .js_prod_main.variant-slider');
      if ($carousel.length) return $carousel.first();
    }

    var $tiles = jQuery('.tcn-pdp-tiles-grid.tcn-pdp-gallery-desktop-only, .tcn-pdp-tiles-grid');
    if (isTilesViewport() && $tiles.length) return $tiles.first();

    return jQuery('.js_prod_main.variant-slider, .variant-slider').first();
  }

  function getGalleryThumbs() {
    return jQuery('.variant-thumbs');
  }

  function getCarouselThumbLayout() {
    if (isMobileGallery() || getDesktopLayout() !== 'carousel') return 'below';
    return window.innerWidth >= CAROUSEL_LEFT_THUMBS_MIN ? 'left' : 'below';
  }

  function toggleCarouselThumbNav($thumbs, layout) {
    var $nav = $thumbs.closest('.variant-thumbs-wrap').find('.tcn-pdp-thumb-nav');
    if (!$nav.length) return;
    if (layout === 'left') {
      $nav.removeAttr('hidden');
    } else {
      $nav.attr('hidden', 'hidden');
    }
  }

  function bindCarouselThumbNav($thumbs) {
    var $wrap = $thumbs.closest('.variant-thumbs-wrap');
    $wrap.find('[data-tcn-thumb-prev]').off('click.tcnPdp').on('click.tcnPdp', function (e) {
      e.preventDefault();
      if ($thumbs.hasClass('slick-initialized')) $thumbs.slick('slickPrev');
    });
    $wrap.find('[data-tcn-thumb-next]').off('click.tcnPdp').on('click.tcnPdp', function (e) {
      e.preventDefault();
      if ($thumbs.hasClass('slick-initialized')) $thumbs.slick('slickNext');
    });
  }

  function run() {
    if (typeof jQuery === 'undefined') return;

    var layout = getDesktopLayout();
    var $slider = getGallerySlider();
    if (!$slider.length) return;

    var $thumbs = getGalleryThumbs();
    var $wrap = $slider.closest('.variant-slider-wrap, .pdp-gallery-scroll-area, .gallery-control');
    var $bar = $wrap.find('.tcn-carousel-scroll-bar').first();
    if (!$bar.length) $bar = jQuery('.tcn-carousel-scroll-bar').first();
    var $thumb = $bar.find('.tcn-carousel-scroll-thumb');
    var useTiles = isTilesViewport() && layout === 'tiles';

    teardown($slider, $thumbs, $wrap, useTiles);

    if (isMobileGallery()) {
      initMobileGallery($slider, $wrap, $bar, $thumb);
      currentMode = 'native';
      currentCarouselThumbLayout = null;
    } else if (useTiles) {
      initDesktopTilesGallery($slider, $wrap);
      currentMode = 'tiles';
      currentCarouselThumbLayout = null;
    } else {
      if (typeof jQuery.fn.slick === 'undefined') return;
      initDesktopGallery($slider, $thumbs, $bar, $thumb);
      currentMode = 'slick';
      currentCarouselThumbLayout = getCarouselThumbLayout();
    }
  }

  function teardown($slider, $thumbs, $wrap, keepTiles) {
    if ($slider.hasClass('slick-initialized')) $slider.slick('unslick');
    if ($thumbs.length && $thumbs.hasClass('slick-initialized')) $thumbs.slick('unslick');
    $slider.removeClass('pdp-gallery-native pdp-gallery-track').off('.tcnPdp');
    if (!keepTiles) {
      $slider.removeClass('pdp-gallery-tiles');
    }
    $slider.removeAttr('data-tcn-pdp-native');
    $wrap.removeClass('pdp-has-native-gallery pdp-has-tiles-gallery');
    if (mobileIO) {
      mobileIO.disconnect();
      mobileIO = null;
    }
    if (tilesIO) {
      tilesIO.disconnect();
      tilesIO = null;
    }
    jQuery(window).off('resize.tcnPdpTiles');
    if (tilesLayoutTimer) {
      clearTimeout(tilesLayoutTimer);
      tilesLayoutTimer = null;
    }
    if (window.TcnPdpZoom && typeof window.TcnPdpZoom.teardown === 'function') {
      window.TcnPdpZoom.teardown();
    }
  }

  function hydrateThumbSrc($thumbs) {
    $thumbs.find('img[data-tcn-thumb-src]').each(function () {
      var $img = jQuery(this);
      var url = $img.attr('data-tcn-thumb-src');
      if (url) {
        $img.attr('src', url).removeAttr('data-tcn-thumb-src');
      }
    });
  }

  function applyLazySrcset($slide) {
    if (!$slide || !$slide.length) return;
    $slide.find('img[data-srcset]').each(function () {
      var $img = jQuery(this);
      if ($img.attr('srcset')) return;
      var srcset = $img.attr('data-srcset');
      var sizes = $img.attr('data-sizes');
      if (srcset) $img.attr('srcset', srcset);
      if (sizes) $img.attr('sizes', sizes);
    });
  }

  function prefetchUrl(url) {
    if (!url || prefetched[url]) return;
    prefetched[url] = true;
    var img = new Image();
    img.decoding = 'async';
    img.src = url;
  }

  function prefetchImg($img) {
    if (!$img || !$img.length) return;
    var mobile = window.innerWidth <= MOBILE_MAX;
    var url = mobile
      ? $img.attr('data-tcn-prefetch') || $img.attr('data-lazy') || $img.attr('src')
      : $img.attr('data-lazy') || $img.attr('data-tcn-prefetch') || $img.attr('src');
    prefetchUrl(url);
  }

  function loadSlideImage($slide) {
    if (!$slide || !$slide.length) return;
    var $img = $slide.find('img.tcn-slide-image, img[data-lazy]').first();
    if (!$img.length) return;

    applyLazySrcset($slide);

    if ($img.attr('src') && !$img.hasClass('slick-loading')) {
      prefetchImg($img);
      return;
    }

    var lazy = $img.attr('data-lazy');
    if (!lazy) return;

    $img.attr('src', lazy).removeAttr('data-lazy').addClass('tcn-slide-loaded');
    applyLazySrcset($slide);
    prefetchImg($img);
  }

  function prefetchSlides($slides, centerIndex, radius) {
    radius = radius || 2;
    var i;
    for (i = 1; i <= radius; i++) {
      if ($slides[centerIndex + i]) loadSlideImage(jQuery($slides[centerIndex + i]));
      if (centerIndex - i >= 0 && $slides[centerIndex - i]) {
        loadSlideImage(jQuery($slides[centerIndex - i]));
      }
    }
  }

  function initMobileGallery($slider, $wrap, $bar, $thumb) {
    var track = $slider[0];
    var scrollBar = $bar[0];
    var thumbEl = $thumb[0];

    $slider.addClass('pdp-gallery-native pdp-gallery-track').attr('data-tcn-pdp-native', 'true');
    $wrap.addClass('pdp-has-native-gallery');

    var $slides = $slider.find(pdpSlideSel(true));

    loadSlideImage($slides.eq(0));
    prefetchSlides($slides.toArray(), 0, 2);

    if ('IntersectionObserver' in window) {
      mobileIO = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) loadSlideImage(jQuery(entry.target));
          });
        },
        { root: track, rootMargin: '80px 0px', threshold: 0.15 }
      );
      $slides.each(function () {
        mobileIO.observe(this);
      });
    } else {
      $slides.each(function () {
        loadSlideImage(jQuery(this));
      });
    }

    function updateScrollBar() {
      if (!track || !scrollBar || !thumbEl) return;
      var maxScroll = track.scrollWidth - track.clientWidth;
      if (maxScroll <= 0) {
        thumbEl.style.transform = 'translateX(0)';
        return;
      }
      var scrollRatio = track.scrollLeft / maxScroll;
      var maxOffset = scrollBar.clientWidth - thumbEl.clientWidth;
      thumbEl.style.transform = 'translateX(' + scrollRatio * maxOffset + 'px)';

      var i = Math.round(track.scrollLeft / track.clientWidth);
      i = Math.max(0, Math.min($slides.length - 1, i));
      prefetchSlides($slides.toArray(), i, 2);
    }

    if (scrollBar && thumbEl) {
      track.addEventListener('scroll', updateScrollBar, { passive: true });
      window.addEventListener('resize', updateScrollBar);
      updateScrollBar();
    }

    if (window.TcnPdpZoom && typeof window.TcnPdpZoom.init === 'function') {
      window.TcnPdpZoom.init(track);
    }
  }

  function getSlideEl(slick, index) {
    return jQuery(slick.$slides.get(index));
  }

  function readSlideAspect(slide) {
    if (!slide) return 1;

    var img = slide.querySelector('img.tcn-slide-image');
    if (img && img.naturalWidth > 0 && img.naturalHeight > 0) {
      return img.naturalWidth / img.naturalHeight;
    }

    var dw = slide.getAttribute('data-tcn-img-w');
    var dh = slide.getAttribute('data-tcn-img-h');
    if (dw && dh) {
      var parsedW = parseFloat(dw);
      var parsedH = parseFloat(dh);
      if (parsedW > 0 && parsedH > 0) return parsedW / parsedH;
    }

    var cssAspect = slide.style.getPropertyValue('--tcn-slide-aspect') ||
      window.getComputedStyle(slide).getPropertyValue('--tcn-slide-aspect');
    if (cssAspect) {
      var parts = cssAspect.trim().split('/');
      if (parts.length === 2) {
        var w = parseFloat(parts[0]);
        var h = parseFloat(parts[1]);
        if (w > 0 && h > 0) return w / h;
      }
    }

    if (img) {
      var attrW = parseInt(img.getAttribute('width'), 10);
      var attrH = parseInt(img.getAttribute('height'), 10);
      if (attrW > 0 && attrH > 0) return attrW / attrH;
    }

    return 1;
  }

  function tileSpanForAspect(aspect) {
    if (aspect >= TILES_WIDE_ASPECT) return TILES_SPAN_FULL;
    if (aspect <= TILES_TALL_ASPECT) return TILES_SPAN_THIRD;
    return TILES_SPAN_HALF;
  }

  function applyTileSpan(slide, span) {
    slide.style.setProperty('--tcn-tile-span', String(span));
    slide.setAttribute('data-tcn-tile-span', String(span));
    if (span >= TILES_SPAN_FULL) {
      slide.style.gridColumn = '1 / -1';
    } else {
      slide.style.gridColumn = 'span ' + span;
    }
  }

  function layoutTilesGrid(grid) {
    if (!grid || window.innerWidth < TILES_MIN) return;

    var slides = grid.querySelectorAll(pdpSlideSel(true));

    /* Retail PDP: fixed 2-up tiles (CSS owns span/aspect). Default keeps masonry spans. */
    if (grid.closest('[data-retail-product]')) {
      slides.forEach(function (slide) {
        slide.style.removeProperty('--tcn-tile-span');
        slide.removeAttribute('data-tcn-tile-span');
        slide.style.removeProperty('grid-column');
      });
      return;
    }

    slides.forEach(function (slide) {
      var span;
      if (slide.classList.contains('tcn-product-slide--image')) {
        span = tileSpanForAspect(readSlideAspect(slide));
      } else {
        span = TILES_SPAN_HALF;
      }
      applyTileSpan(slide, span);
    });
  }

  function scheduleTilesLayout(grid) {
    if (!grid) return;
    clearTimeout(tilesLayoutTimer);
    tilesLayoutTimer = setTimeout(function () {
      layoutTilesGrid(grid);
    }, 80);
  }

  function initDesktopTilesGallery($slider, $wrap) {
    $wrap.addClass('pdp-has-tiles-gallery');

    var grid = $slider[0];
    var $slides = $slider.find(pdpSlideSel(true));

    $slides.each(function () {
      loadSlideImage(jQuery(this));
    });

    layoutTilesGrid(grid);

    $slides.find('img.tcn-slide-image').each(function () {
      var img = this;
      if (img.complete && img.naturalWidth > 0) return;
      img.addEventListener('load', function onTileImgLoad() {
        img.removeEventListener('load', onTileImgLoad);
        scheduleTilesLayout(grid);
      });
    });

    jQuery(window).on('resize.tcnPdpTiles', function () {
      if (currentMode === 'tiles' && isTilesViewport()) scheduleTilesLayout(grid);
    });

    if ('IntersectionObserver' in window) {
      tilesIO = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              loadSlideImage(jQuery(entry.target));
              scheduleTilesLayout(grid);
            }
          });
        },
        { root: null, rootMargin: '120px 0px', threshold: 0.05 }
      );
      $slides.each(function () {
        tilesIO.observe(this);
      });
    }

    if (window.TcnPdpZoom && typeof window.TcnPdpZoom.init === 'function') {
      window.TcnPdpZoom.init($slider[0]);
    }
  }

  function initDesktopGallery($slider, $thumbs, $bar, $thumb) {
    hydrateThumbSrc($thumbs);

    var thumbLayout = getCarouselThumbLayout();
    var leftThumbs = thumbLayout === 'left';
    currentCarouselThumbLayout = thumbLayout;
    toggleCarouselThumbNav($thumbs, thumbLayout);

    $thumbs.slick({
      slide: '.thumb:not([hidden])',
      slidesToShow: leftThumbs ? 4 : 6,
      vertical: leftThumbs,
      verticalSwiping: leftThumbs,
      arrows: false,
      focusOnSelect: true,
      asNavFor: '.variant-slider',
      infinite: false,
      speed: 400,
      cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
      swipe: true,
      swipeToSlide: true,
      touchMove: true,
      accessibility: false
    });

    if (leftThumbs) {
      bindCarouselThumbNav($thumbs);
    }

    $slider.slick({
      slide: pdpSlideSel(true),
      arrows: true,
      lazyLoad: 'ondemand',
      asNavFor: '.variant-thumbs',
      adaptiveHeight: true,
      speed: 400,
      cssEase: 'cubic-bezier(0.4, 0, 0.2, 1)',
      swipe: true,
      swipeToSlide: true,
      touchMove: true,
      waitForAnimate: false,
      accessibility: false
    });

    var slick = $slider.slick('getSlick');

    $slider.on('lazyLoaded.tcnPdp', function (e, s, $slide) {
      applyLazySrcset($slide);
    });

    applyLazySrcset($slider.find('.slick-current'));
    prefetchSlides(slick.$slides.toArray(), slick.currentSlide || 0, 2);

    $slider.on('touchstart.tcnPdp mousedown.tcnPdp', function () {
      prefetchSlides($slider.slick('getSlick').$slides.toArray(), $slider.slick('slickCurrentSlide'), 2);
    });

    $slider.on('beforeChange.tcnPdp', function (e, s, current, next) {
      loadSlideImage(getSlideEl(s, next));
      prefetchSlides(s.$slides.toArray(), next, 2);
    });

    function centerSlickTrack($root) {
      var $list = $root.find('.slick-list');
      var $track = $root.find('.slick-track');
      if (!$list.length || !$track.length) return;
      var lw = $list[0].clientWidth;
      var tw = $track.outerWidth();
      if (tw > 0 && tw < lw) {
        $track.css({ marginLeft: 'auto', marginRight: 'auto' });
      } else {
        $track.css({ marginLeft: '', marginRight: '' });
      }
    }

    function centerBoth() {
      centerSlickTrack($slider);
      if (!leftThumbs) {
        centerSlickTrack($thumbs);
      } else {
        $thumbs.find('.slick-track').css({ marginLeft: '', marginRight: '' });
      }
    }

    $slider.on('setPosition.tcnPdp init.tcnPdp reInit.tcnPdp breakpoint.tcnPdp', centerBoth);
    $thumbs.on('setPosition.tcnPdp init.tcnPdp reInit.tcnPdp breakpoint.tcnPdp', centerBoth);
    centerBoth();

    function setupBar() {
      var count = $slider.slick('getSlick').slideCount;
      $thumb.css('width', 100 / count + '%');
      updateBar(0);
    }

    function updateBar(i) {
      var count = $slider.slick('getSlick').slideCount;
      $thumb.css('transform', 'translateX(' + (i * 100) / count + '%)');
    }

    setupBar();

    $slider.on('afterChange.tcnPdp', function (e, s, i) {
      updateBar(i);
      $thumbs.find('.thumb').removeClass('active').eq(i).addClass('active');
      applyLazySrcset($slider.find('.slick-slide').eq(i));
      prefetchSlides(s.$slides.toArray(), i, 2);
    });

    $thumbs.on('click.tcnPdp', '.thumb', function () {
      var idx = jQuery(this).closest('.slick-slide').data('slick-index');
      $slider.slick('slickGoTo', idx);
    });

    if (window.TcnPdpZoom && typeof window.TcnPdpZoom.init === 'function') {
      window.TcnPdpZoom.init($slider[0]);
    }
  }

  function bindGlobalResize() {
    if (typeof jQuery === 'undefined') return;
    var resizeTimer;
    jQuery(window).on('resize.tcnPdpGlobal orientationchange.tcnPdpGlobal', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        var newMode = isMobileGallery()
          ? 'native'
          : getDesktopLayout() === 'tiles' && isTilesViewport()
            ? 'tiles'
            : 'slick';
        var newThumbLayout = newMode === 'slick' ? getCarouselThumbLayout() : null;
        if (newMode !== currentMode || newThumbLayout !== currentCarouselThumbLayout) {
          currentCarouselThumbLayout = newThumbLayout;
          run();
        } else if (newMode === 'tiles' && isTilesViewport()) {
          var grid = document.querySelector('.tcn-pdp-tiles-grid.tcn-pdp-gallery-desktop-only, .tcn-pdp-tiles-grid');
          scheduleTilesLayout(grid);
        }
      }, 150);
    });
  }

  function boot() {
    bindGlobalResize();
    run();

    document.addEventListener('shopify:section:load', function (event) {
      if (!event.detail || !event.detail.sectionId) return;
      var section = document.getElementById('shopify-section-' + event.detail.sectionId);
      if (!section) return;
      var layoutEl = section.querySelector('[data-pdp-desktop-layout]');
      if (layoutEl) {
        window.TCN_PDP_GALLERY_LAYOUT = layoutEl.getAttribute('data-pdp-desktop-layout');
      }
      run();
    });
  }

  window.TcnPdpGallery = { run: run, init: run, layoutTilesGrid: layoutTilesGrid };

  if (typeof jQuery !== 'undefined') {
    jQuery(boot);
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
